import { Directive } from '@angular/core';

@Directive({
  selector: '[appDialogHeaderMeta]',
  standalone: false,
})
export class DialogHeaderMetaDirective {}
